import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e41b7aa4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "销售占比", -1);
});
var _hoisted_6 = {
  class: "box"
};
var _hoisted_7 = {
  class: "tab"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  key: 0,
  class: "title"
};
var _hoisted_10 = {
  key: 1,
  class: "box"
};
var _hoisted_11 = {
  key: 2,
  class: "box"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title mt-2 flex align-center justify-between"
  }, "销售排行", -1);
});
var _hoisted_13 = {
  class: "rankList"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_bar_echart_mul = _resolveComponent("bar-echart-mul");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_rank_list_item = _resolveComponent("rank-list-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_type_tab, {
    onConfirmType: _ctx.confirmType
  }, null, 8, ["onConfirmType"]), _createVNode(_component_c_date_header_with_btn, {
    ref: "dateRef",
    type: _ctx.params.type,
    onConfirmDate: _ctx.confrimDate,
    onSwitch: _ctx.switchClick
  }, null, 8, ["type", "onConfirmDate", "onSwitch"]), _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index,
          onClick: _ctx.toReportDetail
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  }), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.curTab,
        tabActiveLeft: item === '销量' && item === _ctx.curTab,
        tabActiveRight: item === '金额' && item === _ctx.curTab
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.tabClick(item);
      }
    }, _toDisplayString(item), 11, _hoisted_8);
  }), 128))]), _createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.categoryGoodsCount)), null, 16)]), _ctx.params.type !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "销售趋势")) : _createCommentVNode("", true), _ctx.params.type !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_ctx.dayData.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.dayData)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])) : _createCommentVNode("", true), _ctx.params.type === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_ctx.dayData1.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.dayData1)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])) : _createCommentVNode("", true), _hoisted_12, _createElementVNode("div", _hoisted_13, [_ctx.aggregateSaleRankData.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.aggregateSaleRankData, function (item, index) {
    return _openBlock(), _createBlock(_component_rank_list_item, {
      key: index,
      type: "aggregate",
      item: item,
      index: index
    }, null, 8, ["item", "index"]);
  }), 128)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])])]);
}